import {createDraftSafeSelector} from '@reduxjs/toolkit';

const selectMonitoringState = (state) => state.monitoring;

export const selectCurrentFlowParameters = createDraftSafeSelector(
    selectMonitoringState,
    (state) => state.currentFlowParameters
);

export const selectPageParameters = createDraftSafeSelector(selectMonitoringState, (state) => state.pageParameters);

export const selectCaptivePortalPage = createDraftSafeSelector(
    selectMonitoringState,
    (state) => state.captivePortalPage
);
